<template>
  <div class="container-relatorio">
    <div class="container-tipos-relatorios">
      <label
          @click="selecionarTipoRelatorio(1)"
          :class="{'item-relatorio item-selecionado' : tipoRelatorio === 1, 'item-relatorio item-no-select': tipoRelatorio !== 1}">Relação de pacientes</label>
      <label
          v-if="false"
          @click="selecionarTipoRelatorio(1)"
          :class="{'item-relatorio item-selecionado' : tipoRelatorio === 2, 'item-relatorio item-no-select': tipoRelatorio !== 2}">Relação de atendimentos</label>
    </div>
    <relatorio-paciente-geral v-if="tipoRelatorio === 1"/>
    <relatorio-paciente-atendidos v-if="tipoRelatorio === 2" />
  </div>
</template>

<script>

import RelatorioPacienteGeral from '@/views/pages/relatorios/paciente/RelatorioPacienteGeral.vue'
import RelatorioPacienteAtendidos from '@/views/pages/relatorios/paciente/RelatorioPacienteAtendidos.vue'

export default {
    name: 'RelatorioPaciente',
    components: {RelatorioPacienteAtendidos, RelatorioPacienteGeral},
    data() {
        return {
            tipoRelatorio: 1,
        }
    },
    methods:{
        selecionarTipoRelatorio(tipo){
            this.tipoRelatorio = tipo
        }
    }

}
</script>

<style scoped lang="stylus">

</style>